import { Avatar, AvatarContent, AvatarDescription, AvatarImage, AvatarTitle } from '@playbooks/ui/components/avatar';
import { Link } from '@playbooks/ui/components/link';
import { truncate } from '@playbooks/utils';

export const DetailAvatar = ({ thumbnail, title, text, href, children }) => {
	const content = (
		<Avatar className='flex-start space-x-2'>
			<AvatarImage size='md' src={thumbnail} alt={title} />
			<AvatarContent>
				<AvatarTitle>{truncate(title, 30)}</AvatarTitle>
				{children ? (
					children
				) : (
					<AvatarDescription className='group-hover:underline opacity-80'>{truncate(text, 36)}</AvatarDescription>
				)}
			</AvatarContent>
		</Avatar>
	);

	if (!href) return <div className='flex-between-top gap-3'>{content}</div>;

	return (
		<Link variant='ghost' href={href} className='group flex-between-top gap-3 h-auto p-0'>
			{content}
		</Link>
	);
};
